import React from 'react';
import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';

interface BenefitCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  bullets: string[];
}

export function BenefitCard({ icon: Icon, title, description, bullets }: BenefitCardProps) {
  return (
    <motion.div 
      whileHover={{ y: -5 }}
      className="p-8 bg-white rounded-xl shadow-sm"
    >
      <div className="w-12 h-12 bg-brand-100 rounded-lg flex items-center justify-center mb-4">
        <Icon className="text-brand-600" size={24} />
      </div>
      <h3 className="text-xl font-semibold mb-4">{title}</h3>
      <div className="space-y-4">
        <p className="text-gray-600">{description}</p>
        <ul className="space-y-2 text-gray-600">
          {bullets.map((bullet, index) => (
            <li key={index} className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-brand-500 mt-2" />
              <span>{bullet}</span>
            </li>
          ))}
        </ul>
      </div>
    </motion.div>
  );
}